import React from 'react';
import { Form, Input, Select, InputNumber, Row, Col } from 'antd';
import { useI18n } from 'hooks/useI18n';
import {
	getWorkoutGenderOptions,
	getWorkoutGoalOptions,
	getWorkoutLevelOptions,
} from 'helpers/workoutI18n';

const TemplateMetadataForm = ({ form }) => {
	const { t } = useI18n();
	const genderOptions = getWorkoutGenderOptions(t, 'workouts.template.metadata.gender');
	const levelOptions = getWorkoutLevelOptions(t, 'workouts.template.metadata.level');
	const goalOptions = getWorkoutGoalOptions(t, 'workouts.template.metadata.goal');

	return (
	<Row gutter={12} align="middle" className="template-builder-metadata-form">
		<Col xs={24} sm={7}>
			<Form.Item className="template-builder-metadata-form__item" name="name" rules={[{ required: true, message: t('workouts.template.metadata.template_name_required') }]}>
				<Input placeholder={t('workouts.template.metadata.template_name')} />
			</Form.Item>
		</Col>
		<Col xs={12} sm={3}>
			<Form.Item className="template-builder-metadata-form__item" name="durationDays" rules={[{ required: true }]}>
				<InputNumber min={1} max={365} placeholder={t('workouts.template.metadata.days')} style={{ width: '100%' }} />
			</Form.Item>
		</Col>
		<Col xs={12} sm={4}>
			<Form.Item className="template-builder-metadata-form__item" name="gender">
				<Select placeholder={t('workouts.template.metadata.gender')} options={genderOptions.slice(1)} allowClear />
			</Form.Item>
		</Col>
		<Col xs={12} sm={4}>
			<Form.Item className="template-builder-metadata-form__item" name="level">
				<Select placeholder={t('workouts.template.metadata.level')} options={levelOptions.slice(1)} allowClear />
			</Form.Item>
		</Col>
		<Col xs={12} sm={4}>
			<Form.Item className="template-builder-metadata-form__item" name="goal">
				<Select placeholder={t('workouts.template.metadata.goal')} options={goalOptions.slice(1)} allowClear />
			</Form.Item>
		</Col>
	</Row>
	);
};

export default TemplateMetadataForm;
